export default __webpack_public_path__ + "d09426432241f3bc1c792565805ab4c1.svg";